import { licenseAdapter, LicenseState } from './state';

const { selectAll } = licenseAdapter.getSelectors();

export const getLicenses = selectAll;
export const getLicensesIsLoading = (state: LicenseState) => state.isLoading;
